const Flag = ({ flag, name }) => (
    <span className="nav-ic-language">{flag && <img src={flag} alt={name} title={name} />}</span>
)

export default Flag
